module.exports = __webpack_public_path__ + "media/images/riders/small/RETO_INDERGAND-623dd7331f52444e45514e3714ffb921.png";